import React, { useState } from 'react';
import { Breadcrumb, Button, Layout, Menu, theme, Drawer, Space, Tabs, message, ConfigProvider, Avatar, Divider } from 'antd';
import './TradeRoomMobile.css';
import { LineChartOutlined, FolderOpenOutlined, UserOutlined, DownOutlined, CloseOutlined, ArrowLeftOutlined, ArrowDownOutlined, PlusOutlined, StarOutlined, ArrowUpOutlined } from '@ant-design/icons';
import DarkStockChart from './TradeChart'
import { Input, Radio } from 'antd';
import { Typography, Row, Col } from "antd";
import { LeftOutlined, RightOutlined, MinusOutlined } from "@ant-design/icons";
import { EditOutlined, FacebookOutlined, MessageOutlined } from "@ant-design/icons";
import TradeTable from "../TradeRoom/TradeTable";




const style = {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginBottom: 16,
};


const { Header, Content, Footer } = Layout;

const { TabPane } = Tabs;
const tokenOptions = [
    { key: "cardano", label: "CARDANO (OTC)", subtitle: "Binary", icon: "🌐", return: "+88%" },
    { key: "usdt", label: "USDT (OTC)", subtitle: "", icon: "💵", return: "+88%" },
    { key: "usd", label: "USD (OTC)", subtitle: "", icon: "🇺🇸", return: "+88%" },
    { key: "eur", label: "EURO (OTC)", subtitle: "", icon: "🇪🇺", return: "+88%" },
    { key: "gbp", label: "POUND (OTC)", subtitle: "", icon: "🇬🇧", return: "+88%" },
    { key: "jpy", label: "YEN (OTC)", subtitle: "", icon: "🇯🇵", return: "+88%" },
    { key: "cny", label: "YUAN (OTC)", subtitle: "", icon: "🇨🇳", return: "+88%" },
    { key: "inr", label: "RUPEE (OTC)", subtitle: "", icon: "🇮🇳", return: "+88%" },
    { key: "rub", label: "RUBLE (OTC)", subtitle: "", icon: "🇷🇺", return: "+88%" },
    { key: "aud", label: "AUSSIE (OTC)", subtitle: "", icon: "🇦🇺", return: "+88%" },
    { key: "cad", label: "CANADIAN (OTC)", subtitle: "", icon: "🇨🇦", return: "+88%" },
    { key: "brl", label: "REAL (OTC)", subtitle: "", icon: "🇧🇷", return: "+88%" },
    { key: "mxn", label: "PESO (OTC)", subtitle: "", icon: "🇲🇽", return: "+88%" },
    { key: "zar", label: "RAND (OTC)", subtitle: "", icon: "🇿🇦", return: "+88%" },
    { key: "chf", label: "SWISS FRANC (OTC)", subtitle: "", icon: "🇨🇭", return: "+88%" },
    { key: "sek", label: "KRONA (OTC)", subtitle: "", icon: "🇸🇪", return: "+88%" },
    { key: "nok", label: "KRONE (OTC)", subtitle: "", icon: "🇳🇴", return: "+88%" },
    { key: "dkk", label: "DANISH KRONE (OTC)", subtitle: "", icon: "🇩🇰", return: "+88%" },
    { key: "sgd", label: "SINGAPORE DOLLAR (OTC)", subtitle: "", icon: "🇸🇬", return: "+88%" },
    { key: "hkd", label: "HONG KONG DOLLAR (OTC)", subtitle: "", icon: "🇭🇰", return: "+88%" },
    { key: "krw", label: "WON (OTC)", subtitle: "", icon: "🇰🇷", return: "+88%" },
    { key: "thb", label: "BAHT (OTC)", subtitle: "", icon: "🇹🇭", return: "+88%" },
    { key: "vnd", label: "DONG (OTC)", subtitle: "", icon: "🇻🇳", return: "+88%" },
    { key: "idr", label: "RUPIAH (OTC)", subtitle: "", icon: "🇮🇩", return: "+88%" },
    { key: "myr", label: "RINGGIT (OTC)", subtitle: "", icon: "🇲🇾", return: "+88%" },
    { key: "php", label: "PESO (OTC)", subtitle: "", icon: "🇵🇭", return: "+88%" },
    { key: "try", label: "LIRA (OTC)", subtitle: "", icon: "🇹🇷", return: "+88%" },
    { key: "pln", label: "ZLOTY (OTC)", subtitle: "", icon: "🇵🇱", return: "+88%" },
    { key: "ngn", label: "NAIRA (OTC)", subtitle: "", icon: "🇳🇬", return: "+88%" },
    { key: "egp", label: "EGYPTIAN POUND (OTC)", subtitle: "", icon: "🇪🇬", return: "+88%" },
];



const dataclosed = [
    {
        date: "Yesterday",
        trades: [
            {
                flag: "🇪🇺", // you can replace with img src
                pair: "EUR/USD (OTC)",
                type: "Binary",
                amount: "$1,000",
                result: "$0",
                percent: "0%",
                arrow: "up",
                profitColor: "white",
            },
            {
                flag: "🇪🇺",
                pair: "EUR/USD (OTC)",
                type: "Binary",
                amount: "$1,000",
                result: "$1,860",
                percent: "+186%",
                arrow: "down",
                profitColor: "limegreen",
            },
            {
                flag: "🇪🇺",
                pair: "EUR/USD (OTC)",
                type: "Binary",
                amount: "$1,502",
                result: "$0",
                percent: "0%",
                arrow: "up",
                profitColor: "white",
            },
        ],
    },
    {
        date: "Oct 1",
        trades: [
            {
                flag: "🇪🇺",
                pair: "EUR/USD (OTC)",
                type: "Binary",
                amount: "$1",
                result: "$1.86",
                percent: "+186%",
                arrow: "up",
                profitColor: "limegreen",
            },
        ],
    },
    {
        date: "Sep 30",
        trades: [
            {
                flag: "🇪🇺",
                pair: "EUR/USD (OTC)",
                type: "Binary",
                amount: "$2,000",
                result: "$0",
                percent: "0%",
                arrow: "up",
                profitColor: "white",
            },
        ],
    },
];



const categories = [
    "All",
    "Currency pairs",
    "Equities",
    "Commodities",
    "Crypto",
    "Indices",
    "Bonds",
];

const { Text } = Typography;

const TradeRoomMobile = () => {
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();


    //Drawer
    const [open, setOpen] = useState(false);
    const [paymentOpen, setPaymentOpen] = useState(false);
    const [balanceHistoryOpen, setBalanceHistoryOpen] = useState(false);
    const [placement, setPlacement] = useState('right');
    const [placementRight, setPlacementright] = useState('right');
    const [balanceHistory, setBalanceHistory] = useState('bottom');
    const [active, setActive] = useState("All");
    const [time, setTime] = useState("14:28");
    const [amount, setAmount] = useState(1);
    const [activeKeyFile, setActiveKeyFile] = useState("1");




    const [value, setValue] = useState(1);
    const onChangeRadio = e => {
        setValue(e.target.value);
    };


    const showDrawer = () => {
        setOpen(true);
    };
    const onChange = e => {
        setPlacement(e.target.value);
    };
    const onClose = () => {
        setOpen(false);
    };


    const showDrawerRight = () => {
        setPaymentOpen(true);
    };
    const onChangeRight = e => {
        setPlacementright(e.target.value);
    };
    const onCloseRight = () => {
        setPaymentOpen(false);
    };

    const showDrawerinner = () => {
        setBalanceHistoryOpen(true);
    };
    const onChangebalance = e => {
        setBalanceHistory(e.target.value);
    };
    const onclosebalance = () => {
        setBalanceHistoryOpen(false);
    };


    // bottm tab

    const [tabPosition, setTabPosition] = useState('bottom');

    const changeTabPosition = e => {
        setTabPosition(e.target.value);
    };
    const onChangeBottm = key => {
        console.log(key);
    };
    const items = [
        {
            key: '1',
            label: 'Tab 1',
            children: 'Content of Tab Pane 1',
        },
        {
            key: '2',
            label: 'Tab 2',
            children: 'Content of Tab Pane 2',
        },
        {
            key: '3',
            label: 'Tab 3',
            children: 'Content of Tab Pane 3',
        },
    ];
    //   message

    const [messageApi, contextHolder] = message.useMessage();
    const success = () => {
        messageApi.open({
            type: 'success',
            content: 'Under development',
        });
    };

    // bottom tab activation

    const [activeTab, setActiveTab] = useState("chart");

    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };


    // header tabs

    //     const [size, setSize] = useState('small');
    //   const [activeKey, setActiveKey] = useState('1');
    //   const [itemstab, setItemstab] = useState([
    //     {
    //       label: 'Tab 1',
    //       key: '1',
    //       children: 'Content of editable tab 1',
    //     },
    //     {
    //       label: 'Tab 2',
    //       key: '2',
    //       children: 'Content of editable tab 2',
    //     },
    //     {
    //       label: 'Tab 3',
    //       key: '3',
    //       children: 'Content of editable tab 3',
    //     },
    //   ]);
    //   const add = () => {
    //     const newKey = String((itemstab || []).length + 1);
    //     setItemstab([
    //       ...(itemstab || []),
    //       {
    //         label: `Tab ${newKey}`,
    //         key: newKey,
    //         children: `Content of editable tab ${newKey}`,
    //       },
    //     ]);
    //     setActiveKey(newKey);
    //   };
    //   const remove = targetKey => {
    //     if (!itemstab) return;
    //     const targetIndex = itemstab.findIndex(itemstab => itemstab.key === targetKey);
    //     const newItems = itemstab.filter(itemstab => itemstab.key !== targetKey);
    //     if (newItems.length && targetKey === activeKey) {
    //       const newActiveKey =
    //         newItems[targetIndex === newItems.length ? targetIndex - 1 : targetIndex].key;
    //       setActiveKey(newActiveKey);
    //     }
    //     setItemstab(newItems);
    //   };
    //   const onEdit = (targetKey, action) => {
    //     if (action === 'add') {
    //       add();
    //     } else {
    //       remove(targetKey);
    //     }
    //   };
    //   const onChangetab = e => {
    //     setSize(e.target.value);
    //   };

    const [activeKey, setActiveKey] = useState("cardano");
    const initialTabKey = "cardano"; // cannot be removed

    const [itemstab, setItems] = useState([
        {
            key: "cardano",
            label: renderTab("cardano", "CARDANO (OTC)", "Binary", "🌐", true),
            children: "Cardano content",
        },
    ]);
    const [drawerOpen, setDrawerOpen] = useState(false);

    // Render function for tab label
    function renderTab(key, label, subtitle, icon, expanded) {
        //   const isInitialTab = key === initialTabKey;
        const showClose = expanded && key !== initialTabKey; // × only for removable tabs
        return (
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    gap: 8,
                    justifyContent: "space-between",
                    width: "100%",
                }}
            >
                <div
                    style={{
                        width: 36,
                        height: 36,
                        borderRadius: 8,
                        // background: "#1677ff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        color: "#fff",
                        fontSize: 16,
                        position: "relative",
                    }}
                >
                    {icon}
                    {/* OTC badge */}
                    <span
                        style={{
                            position: "absolute",
                            bottom: -6,
                            right: -6,
                            background: "#ff8a00",
                            color: "white",
                            fontSize: 9,
                            padding: "1px 4px",
                            borderRadius: 8,
                        }}
                    >
                        OTC
                    </span>
                </div>

                {expanded && (
                    <>
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                lineHeight: 1,
                                width: "100%",
                            }}
                        >
                            <span style={{ fontSize: 13, fontWeight: 600 }} className='tab-label'>{label}</span>
                            {subtitle && (
                                <span style={{ fontSize: 11, color: "#999" }}>{subtitle}</span>
                            )}
                        </div>

                        {showClose && (
                            <div
                                style={{
                                    marginLeft: "auto",
                                    fontSize: 16,
                                    cursor: "pointer",
                                    color: "#999",
                                }}
                                onClick={(e) => {
                                    e.stopPropagation();
                                    removeTab(key);
                                }}
                            >
                                ×
                            </div>
                        )}
                    </>
                )}
            </div>
        );
    }

    const addTab = (token) => {
        if (itemstab.find((i) => i.key === token.key)) {
            setActiveKey(token.key);
            setDrawerOpen(false);
            return;
        }
        const newTab = {
            key: token.key,
            label: renderTab(
                token.key,
                token.label,
                token.subtitle,
                token.icon,
                true
            ),
            children: `${token.label} content`,
        };
        setItems((prev) => {
            const updated = [...prev, newTab];
            // Update all tabs so only the new tab is expanded
            return updated.map((t) => {
                const tokenData = tokenOptions.find((o) => o.key === t.key);
                return {
                    ...t,
                    label: renderTab(
                        t.key,
                        tokenData.label,
                        tokenData.subtitle,
                        tokenData.icon,
                        t.key === token.key // only new tab expanded
                    ),
                };
            });
        });
        setActiveKey(token.key);
        setDrawerOpen(false);
    };

    const removeTab = (key) => {
        const newItems = itemstab.filter((i) => i.key !== key);
        setItems(newItems);
        if (newItems.length) {
            setActiveKey(newItems[0].key);
        }
    };

    const onChangetab = (key) => {
        setActiveKey(key);
        setItems((prev) =>
            prev.map((t) => {
                const token = tokenOptions.find((o) => o.key === t.key);
                return {
                    ...t,
                    label: renderTab(
                        t.key,
                        token.label,
                        token.subtitle,
                        token.icon,
                        t.key === key
                    ),
                };
            })
        );
    };


    // assets tab

    const onChangeassets = key => {
        console.log(key);
    };
    const itemsasset = [
        {
            key: '1',
            label: 'Blitz',
            children: 'Content of Tab Pane 1',
        },
        {
            key: '2',
            label: 'Binary',
            children: 'Content of Tab Pane 2',
        },
    ];


    // table data
    const columns = [
        { title: "Pair", dataIndex: "name" },
        { title: "Qty", dataIndex: "quantity", align: "right" },
        { title: "Used Margin", dataIndex: "margin", align: "center" },
        { title: "Open Price", dataIndex: "open", align: "center" },
        { title: "LTP", dataIndex: "current", align: "center" },
        { title: "TP", dataIndex: "takeProfit", editable: true, align: "center" },
        { title: "SL", dataIndex: "stopLoss", editable: true, align: "center" },
        {
            title: "Net P/L",
            dataIndex: "pnl",
            render: (text) => (
                <span style={{ color: text > 0 ? "limegreen" : "red" }}>
                    {text > 0 ? `+$${text}` : `-$${Math.abs(text)}`}
                </span>
            )
            , align: "center"
        }, {
            title: "",
            dataIndex: "closepnl"
        }

    ];


    const data = [
        {
            key: "1",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/gold-bars.png" alt="gold-bars" />
                Gold
            </div>,
            quantity: null,  // not shown in image
            margin: "$3,785.79",
            open: 3785.790,
            current: 3771.590,
            takeProfit: "Add",
            stopLoss: "Add",
            pnl: -66.23,
            totalPnl: -776.23,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "1",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/gold-bars.png" alt="gold-bars" />
                Gold
            </div>,
            quantity: null,  // not shown in image
            margin: "$3,785.79",
            open: 3785.790,
            current: 3771.590,
            takeProfit: "Add",
            stopLoss: "Add",
            pnl: -66.23,
            totalPnl: -776.23,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        }, {
            key: "1",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/gold-bars.png" alt="gold-bars" />
                Gold
            </div>,
            quantity: null,  // not shown in image
            margin: "$3,785.79",
            open: 3785.790,
            current: 3771.590,
            takeProfit: "Add",
            stopLoss: "Add",
            pnl: -66.23,
            totalPnl: -776.23,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },
        {
            key: "2",
            name: <div className="display-1">
                <img width="25" height="25" src="https://img.icons8.com/color/25/usa-circular.png" alt="usa-circular" />
                US 30
            </div>,
            quantity: null,  // not shown in image
            margin: "$464.40",
            open: 46440.400,
            current: 46381.600,
            takeProfit: "Add",
            stopLoss: 46000.000,
            pnl: -13.47,
            totalPnl: -72.27,
            closepnl: <Button type="primary" style={{ background: "transparent", border: "1px solid #cccccc34", width: "80%" }}>
                Close
            </Button>
        },


    ];



    const bgColor = '#000';
    return (
        <Layout style={{ height: '100vh', background: bgColor }}>
            {activeTab !== "profile" && (
                <Header
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        background: bgColor,
                        padding: '0px 10px',
                        height: "80px",
                        // borderBottom: '1px solid #3B4253'
                    }}
                >

                    <div className="act-amt-mb cursor" onClick={showDrawer}>
                        <div className="act-tpy-mob display-1">
                            Real account
                            <DownOutlined style={{ color: "#cccccca2" }} />
                        </div>
                        $17,071.33
                    </div>

                    <Button style={{ background: "transparent", color: "#fff", border: "1px solid #0092e4" }} variant="outlined" onClick={showDrawerRight}>Payment</Button>



                </Header>
            )}
            <div>

                <div className='bottom-drawer'>
                    <Drawer
                        title="Your accounts"
                        placement={"bottom"}
                        onClose={onClose}
                        open={open}
                        closable={true}
                        getContainer={false}
                        closeIcon={<CloseOutlined style={{ color: "#888" }} />}
                    >
                        {/* <Radio.Group
                        style={style}
                        onChange={onChangeRadio}
                        value={value}
                        options={[
                            {
                                value: 1,
                                 label:
                                 <div className="act-amt-mb cursor" >
                                    <div className="act-tpy-mob display-1">
                                        Real account
                                    </div>
                                    $17,071.33
                                    {value === 1 && (
                                        <div className="display-3 justi-evenly mt-10 mb-10 gap-5">
                                            <Button type="primary" className="withdraw-btn">
                                                Withdraw
                                            </Button>
                                            <Button className="Deposit-btn">Deposit</Button>
                                        </div>
                                    )}

                                </div>


                            },
                            {
                                value: 2, label:
                                    <div className="act-amt-mb cursor" >
                                        <div className="act-tpy-mob display-1">
                                            Demo account
                                        </div>
                                        $17,071.33
                                    </div>
                            },

                        ]}
                    /> */}

                        <div className="flex flex-col gap-5">
                            <ConfigProvider
                                theme={{
                                    token: {
                                        colorPrimary: "#0092e4",
                                    },
                                }}
                            >
                                <Radio.Group onChange={onChangeRadio} value={value} style={style}>
                                    <Radio value={1}>
                                        <div className="act-amt-mb cursor flex justify-between items-center w-80">
                                            <div className="act-tpy-mob display-1">Real account</div>
                                            <div>$17,071.33</div>
                                        </div>
                                    </Radio>
                                </Radio.Group>
                            </ConfigProvider>

                            {value === 1 && (
                                <div className="display-3 space-evenly gap-5 mt-10 mb-10">
                                    <Button type="primary" className="withdraw-btn w-1/2">
                                        Withdraw
                                    </Button>
                                    <Button className="Deposit-btn w-1/2">Deposit</Button>
                                </div>
                            )}

                            <ConfigProvider
                                theme={{
                                    token: {
                                        colorPrimary: "#0092e4",
                                    },
                                }}
                            >
                                <Radio.Group onChange={onChangeRadio} value={value} style={style}>
                                    <Radio value={2}>
                                        <div className="act-amt-mb cursor flex justify-between items-center w-80">
                                            <div className="act-tpy-mob display-1">Demo account</div>
                                            <div>$17,071.33</div>
                                        </div>
                                    </Radio>
                                </Radio.Group>
                            </ConfigProvider>


                            {value === 2 && (
                                <div className="display-3 space-evenly gap-5 mt-10 mb-10">
                                    <Button className="top-up-btn w-1/2">Top up</Button>
                                </div>
                            )}
                        </div>




                    </Drawer>
                </div>

                <Drawer
                    title=""
                    placement={"right"}
                    onClose={onCloseRight}
                    width={500}
                    open={paymentOpen}
                    closable={false}
                    style={{ background: "#000" }}
                    headerStyle={{ display: "none" }}


                >
                    <div className="">
                        <ArrowLeftOutlined
                            onClick={onCloseRight}
                            style={{ fontSize: "16px", color: "#888", cursor: "pointer" }}
                        />
                        <div>
                            <div style={{ display: "flex", flexDirection: "column", alignItems: "center", marginTop: "20px" }}>
                                <div style={{ color: "#fff", fontSize: "22px", fontWeight: "600", marginBottom: "10px" }}>
                                    $6.41
                                </div>
                                <div className="act-tpy-mob display-1">Real account</div>
                            </div>

                            <div className="display-3 justi-evenly mt-10 gap-5">
                                <Button type="primary" className="withdraw-btn a3">
                                    <ArrowDownOutlined /> Withdraw
                                </Button>
                                <Button className="Deposit-btn a3"><PlusOutlined />  Deposit</Button>
                            </div>

                            <div className='' style={{ color: "#888", fontSize: "14px", marginTop: "20px" }}>Balance history</div>
                            <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px", flexDirection: "column", padding: "0 18px" }}>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowDownOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Withdraw</div>
                                            <div className='gray mb-10'>05:17</div>
                                            <div className='gray mb-10'>commission</div>
                                        </div>
                                    </div>
                                    <div style={{ color: "#fff" }}>$9,794</div>
                                </div>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowDownOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Withdraw</div>
                                            <div className='gray'>04:58</div>
                                        </div>
                                    </div>
                                    <div style={{ color: "#fff" }}>$9,794</div>
                                </div>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowUpOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Deposit</div>
                                            <div className='gray'>15:30</div>
                                        </div>
                                    </div>
                                    <div className='green' >$29,997</div>
                                </div>




                            </div>

                            <div>
                                <Button className="mt-20" style={{ width: "100%", background: "transparent", border: "1px solid #242b35", color: "#fff", fontWeight: "600", padding: "20px 0", }}
                                // onClick={showDrawerinner}
                                >Show all</Button>
                            </div>
                        </div>


                    </div>



                </Drawer>

                <div className='bottom-full-drawer'>
                    <Drawer
                        title=""
                        placement={"right"}
                        onClose={onclosebalance}
                        width={500}
                        open={balanceHistoryOpen}
                        closable={false}
                        style={{ background: "#000" }}
                        headerStyle={{ display: "none" }}
                        className='balance-drawer'
                    >
                        <div className="display-5" style={{ background: "#000", padding: "10px 0px", display: "flex", justifyContent: "space-between", position: "sticky", top: 0 }}>
                            <div className='display-2 gap-15'>
                                <ArrowLeftOutlined
                                    onClick={onclosebalance}
                                    style={{ fontSize: "16px", color: "#888", cursor: "pointer" }}
                                />
                                <div className='white'>Balance History</div>

                            </div>
                            <ArrowLeftOutlined style={{ fontSize: "16px", color: "#888", cursor: "pointer" }} />
                        </div>

                        <div>
                            <div className='gray mt-20'>oct 2, 2025</div>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", padding: "0 18px" }}>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowDownOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Withdraw</div>
                                            <div className='gray mb-10'>05:17</div>
                                            <div className='gray mb-10'>commission</div>
                                        </div>
                                    </div>
                                    <div style={{ color: "#fff" }}>$9,794</div>
                                </div>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowDownOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Withdraw</div>
                                            <div className='gray'>04:58</div>
                                        </div>
                                    </div>
                                    <div style={{ color: "#fff" }}>$9,794</div>
                                </div>
                            </div>
                        </div>

                        <div className='mt-10'>
                            <div className='gray mt-20'>jul 7, 2025</div>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", padding: "0 18px" }}>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowDownOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Deposit</div>
                                            <div className='gray'>15:30</div>
                                        </div>
                                    </div>
                                    <div className='green' >$29,997</div>
                                </div>
                            </div>
                        </div>

                        <div className='mt-10'>
                            <div className='gray mt-20'>jun 7, 2025</div>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", padding: "0 18px" }}>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowDownOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Dividend adjustment</div>
                                            <div className='gray'>20:04</div>
                                        </div>
                                    </div>
                                    <div style={{ color: "#fff" }}>$7.67</div>
                                </div>
                            </div>
                        </div>

                        <div className='mt-10'>
                            <div className='gray mt-20'>may 19, 2025</div>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", padding: "0 18px" }}>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowDownOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Withdrawal</div>
                                            <div className='gray'>19.21</div>
                                        </div>
                                    </div>
                                    <div style={{ color: "#fff" }}>$13</div>
                                </div>
                            </div>
                        </div>

                        <div className='mt-10'>
                            <div className='gray mt-20'>apr 8, 2025</div>
                            <div style={{ display: "flex", justifyContent: "space-between", flexDirection: "column", padding: "0 18px" }}>
                                <div className='display-5 align-baseline mt-20'>
                                    <div className='display-1'>
                                        <div >
                                            <ArrowDownOutlined style={{ color: "#fff", fontSize: "16px" }} />
                                        </div>
                                        <div>
                                            <div className='white mb-10'>Deposit</div>
                                            <div className='gray'>21.04</div>
                                        </div>
                                    </div>
                                    <div className='green'>$500,000</div>
                                </div>
                            </div>
                        </div>

                    </Drawer>
                </div>
            </div>

            <Content style={{ padding: '0 5px', display: "flex", flexDirection: 'column' }}>
                {activeTab === "chart" &&
                    <>
                        <div>
                            <Tabs
                                type="card"
                                // hideAdd
                                activeKey={activeKey}
                                onChange={onChangetab}
                                items={itemstab}
                                className='tab-header-fu'
                                tabBarExtraContent={{
                                    right: (
                                        <Button
                                            type="text"
                                            icon={<PlusOutlined style={{ color: "#fff", padding: "15px" }} />}
                                            onClick={() => setDrawerOpen(true)}
                                        />
                                    ),
                                }}
                            />

                            <Drawer
                                title="choose an asset"
                                placement={"right"}
                                width={500}
                                style={{ background: "#000" }}
                                open={drawerOpen}
                                onClose={() => setDrawerOpen(false)}
                                headerStyle={{ display: "none" }}
                                className='balance-drawer a3'
                                closable={false}

                            >
                                <div className="display-5" style={{ background: "#000", padding: "20px 0px", display: "flex", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 999 }}>
                                    <div className='display-2 gap-15'>
                                        <ArrowLeftOutlined
                                            onClick={() => setDrawerOpen(false)}
                                            style={{ fontSize: "16px", color: "#888", cursor: "pointer" }}
                                        />
                                        <div className='white'>choose an asset</div>

                                    </div>
                                    <img width="14" height="14" src="https://img.icons8.com/ios-filled/50/search--v1.png" style={{ filter: 'brightness(0) invert(1)' }} alt="search--v1" />                                </div>

                                <div>
                                    <Tabs
                                        defaultActiveKey="1"
                                        onChange={onChangeassets}
                                        items={itemsasset}
                                        className="fullwidth-tabs"
                                        style={{ color: "#fff" }}
                                    />
                                </div>


                                <div
                                    style={{
                                        display: "flex",
                                        overflowX: "auto",
                                        gap: "10px",
                                        padding: "8px",
                                        scrollbarWidth: "none", // Firefox
                                    }}
                                >
                                    {categories.map((cat) => (
                                        <button
                                            key={cat}
                                            onClick={() => setActive(cat)}
                                            style={{
                                                padding: "6px 14px",
                                                borderRadius: "20px",
                                                border: "none",
                                                whiteSpace: "nowrap",
                                                cursor: "pointer",
                                                background: active === cat ? "#fff" : "rgba(255,255,255,0.1)",
                                                color: active === cat ? "#000" : "#fff",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                flexShrink: 0, // prevent shrinking
                                            }}
                                        >
                                            {cat}
                                        </button>
                                    ))}


                                    <style>{`
        div::-webkit-scrollbar {
          display: none;
        }
      `}</style>
                                </div>

                                <div className='display-5 mt-20'>
                                    <div className='gray'>Asset</div>
                                    <div className='gray'>Return</div>
                                </div>

                                {tokenOptions.map((token) => (
                                    <>
                                        <div className='display-5'>
                                            <div
                                                key={token.key}
                                                onClick={() => addTab(token)}
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 10,
                                                    padding: "10px 0",
                                                    cursor: "pointer",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: 40,
                                                        height: 40,
                                                        borderRadius: 8,
                                                        // background: "#1677ff",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        color: "#fff",
                                                    }}
                                                >
                                                    {token.icon}
                                                </div>
                                                <div className='add-tabs'>
                                                    <div style={{ fontWeight: 600, color: "#fff" }}>{token.label}</div>
                                                    {token.subtitle && (
                                                        <div style={{ fontSize: 12, color: "#999" }}>
                                                            {token.subtitle}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                            <div>
                                                <div className='display-1'>
                                                    <div className='green display-2 gap-5' >{token.return} <div className='img-white'>
                                                        <StarOutlined style={{ color: "#fff" }} /></div> </div>
                                                </div>
                                            </div>
                                        </div>

                                    </>
                                ))}
                            </Drawer>
                        </div>
                        <div
                            style={{

                                height: "100%",
                                display: 'flex',
                                flexDirection: "column",

                            }}
                        >
                            <DarkStockChart />
                            {/* <Tabs tabPosition={tabPosition} items={items} onChange={changeTabPosition} className='mobile-bottom-tab' /> */}

                        </div>
                        <div className='display-2 gap-15 mt-10'>
                            <Button className='btn-chart'> Down</Button>
                            <Button className='btn-chart2' onClick={() => handleTabChange("files")} style={{ color: "#fff", display: "flex", alignItems: "center", justifyContent: "space-evenly" }}>UP</Button>
                        </div>
                        <div>
                            <div className='display-2 gap-15 mt-10' style={{ color: "#fff", marginTop: "10px", display: "flex", alignItems: "center", justifyContent: "center", gap: "10px" }}>

                                <div style={{ width: "100%" }}>
                                    <div style={{ display: "block", marginBottom: "6px", textAlign: "center", color: "#fff" }}>
                                        Timer
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-evenly",
                                            background: "#1c252f",
                                            borderRadius: "10px",
                                            padding: "6px 12px",
                                            // minWidth: "140px",
                                            width: "45% !important"
                                        }}
                                    >
                                        <Button type="text" icon={<LeftOutlined />} style={{ color: "#fff" }} />
                                        <Text style={{ fontSize: "16px", fontWeight: 500, color: "#fff" }}>{time}</Text>
                                        <Button type="text" icon={<RightOutlined />} style={{ color: "#fff" }} />
                                    </div>
                                </div>

                                {/* Amount Box */}
                                <div style={{ width: "100%" }}>
                                    <div style={{ display: "block", marginBottom: "6px", textAlign: "center" }}>
                                        Amount ($)
                                    </div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            background: "#1c252f",
                                            borderRadius: "10px",
                                            padding: "6px 12px",
                                            // minWidth: "120px",
                                            width: "45% !important"
                                        }}
                                    >
                                        <Button
                                            type="text"
                                            icon={<MinusOutlined />}
                                            style={{ color: "#fff" }}
                                            onClick={() => setAmount((prev) => Math.max(1, prev - 1))}
                                        />
                                        <div style={{ fontSize: "16px", fontWeight: 500, color: "#fff" }}>{amount}</div>
                                        <Button
                                            type="text"
                                            icon={<PlusOutlined />}
                                            style={{ color: "#fff" }}
                                            onClick={() => setAmount((prev) => prev + 1)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
                {activeTab === "files" && <div style={{ color: "#fff", height: "100%" }}>

                    <div className='white' style={{ color: "#fff", fontWeight: 600, padding: "10px", fontSize: 18 }}>My Trades</div>
                    <div>
                        <Tabs
                            activeKey={activeKeyFile}
                            onChange={setActiveKeyFile}
                            centered
                            className="status-tabs"
                        >
                            <TabPane tab="Active" key="1">
                                <div>

                                    <TradeTable columns={columns} data={data} scroll={{ y: 170, x: 800 }} className={"trade-table"} />
                                </div>
                            </TabPane>
                            <TabPane tab="Closed" key="2">
                                {/* <div className="trade-history">
                                    {dataclosed.map((section, i) => (
                                        <div key={i}>
                                            <Divider orientation="left" plain className="date-divider">
                                                {section.date}
                                            </Divider>
                                            {section.trades.map((trade, j) => (
                                                <div className="trade-row" key={j}>
                                                    <div className="left">
                                                        <span className="flag">{trade.flag}</span>
                                                        <span className="pair">{trade.pair}</span>
                                                        <span className="badge">OTC</span>
                                                        <div className="type">{trade.type}</div>
                                                    </div>
                                                    <div className="right">
                                                        <div className="amount">{trade.amount}</div>
                                                        <div className="result">
                                                            {trade.result}{" "}
                                                            {trade.arrow === "up" ? (
                                                                <ArrowUpOutlined style={{ color: "skyblue" }} />
                                                            ) : (
                                                                <ArrowDownOutlined style={{ color: "red" }} />
                                                            )}
                                                        </div>
                                                        <div className="percent" style={{ color: trade.profitColor }}>
                                                            {trade.percent}
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ))}
                                </div> */}
                            </TabPane>
                        </Tabs>



                    </div>

                </div>}
                {activeTab === "profile" &&
                    <>
                        <div style={{ backgroundColor: "#000", }}>
                            <div style={{ margin: "0 auto", padding: 16, backgroundColor: "#000", color: "#fff" }}>
                                <div
                                    style={{ textAlign: "center", backgroundColor: "#000", borderRadius: 12 }}
                                    className="card-profile"
                                >
                                    <Avatar size={64} icon={<UserOutlined />} style={{ background: "#1e1e1e" }} />
                                    <div className="test display-3 gap-5 align-baseline ">
                                        <div style={{ marginTop: 16, color: "#fff" }}>Test Test</div>
                                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5001 1.44324C17.0566 1.44324 21.5627 5.9494 21.5627 11.5058C21.5627 17.0623 17.0566 21.5685 11.5001 21.5685C5.94366 21.5685 1.4375 17.0623 1.4375 11.5058C1.4375 5.9494 5.94366 1.44324 11.5001 1.44324ZM9.41048 14.7743L6.94691 12.3086C6.5272 11.8887 6.52711 11.2039 6.94691 10.784C7.36679 10.3642 8.05467 10.3668 8.47149 10.784L10.2083 12.5222L14.5289 8.20157C14.9488 7.78169 15.6337 7.78169 16.0535 8.20157C16.4733 8.62136 16.4727 9.30686 16.0535 9.72615L10.9694 14.8103C10.5501 15.2295 9.86457 15.2301 9.44477 14.8103C9.43298 14.7985 9.4216 14.7865 9.41048 14.7743Z" fill="#009A2D" />
                                        </svg>
                                    </div>
                                    <div className="display-3 gap-5 align-baseline">
                                        <p style={{ color: "#888" }}>User ID #177595946</p>
                                        <div>
                                            <svg width="15" height="17" viewBox="0 0 15 17" fill="#888" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.99805 17H2.65625C1.19155 17 0 15.8084 0 14.3438V5.3457C0 3.881 1.19155 2.68945 2.65625 2.68945H8.99805C10.4627 2.68945 11.6543 3.881 11.6543 5.3457V14.3438C11.6543 15.8084 10.4627 17 8.99805 17ZM2.65625 4.01758C1.92397 4.01758 1.32812 4.61342 1.32812 5.3457V14.3438C1.32812 15.076 1.92397 15.6719 2.65625 15.6719H8.99805C9.73033 15.6719 10.3262 15.076 10.3262 14.3438V5.3457C10.3262 4.61342 9.73033 4.01758 8.99805 4.01758H2.65625ZM14.3105 12.6836V2.65625C14.3105 1.19155 13.119 0 11.6543 0H4.2832C3.91641 0 3.61914 0.297272 3.61914 0.664062C3.61914 1.03085 3.91641 1.32812 4.2832 1.32812H11.6543C12.3866 1.32812 12.9824 1.92397 12.9824 2.65625V12.6836C12.9824 13.0504 13.2797 13.3477 13.6465 13.3477C14.0133 13.3477 14.3105 13.0504 14.3105 12.6836Z" fill="#F6F6F7" />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="display-5 gap-5 mt-20 border-promo">
                                        <div>
                                            <div>promo center</div>
                                            <div style={{ color: "#888", fontSize: "12px", marginTop: "10px" }}>1 promo available</div>
                                        </div>

                                        {/* <img
                                            src="https://upload.wikimedia.org/wikipedia/commons/7/7c/Megaphone_icon.png"
                                            alt="promo"
                                            style={{ width: 32, height: 32 }}
                                        /> */}
                                    </div>
                                </div>




                                <div style={{ marginTop: 16, }}>

                                    <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                        <div className="display-2 gap-10">
                                            <div>
                                                <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M11.5001 1.44324C17.0566 1.44324 21.5627 5.9494 21.5627 11.5058C21.5627 17.0623 17.0566 21.5685 11.5001 21.5685C5.94366 21.5685 1.4375 17.0623 1.4375 11.5058C1.4375 5.9494 5.94366 1.44324 11.5001 1.44324ZM9.41048 14.7743L6.94691 12.3086C6.5272 11.8887 6.52711 11.2039 6.94691 10.784C7.36679 10.3642 8.05467 10.3668 8.47149 10.784L10.2083 12.5222L14.5289 8.20157C14.9488 7.78169 15.6337 7.78169 16.0535 8.20157C16.4733 8.62136 16.4727 9.30686 16.0535 9.72615L10.9694 14.8103C10.5501 15.2295 9.86457 15.2301 9.44477 14.8103C9.43298 14.7985 9.4216 14.7865 9.41048 14.7743Z" fill="#009A2D" />
                                                </svg>
                                            </div>
                                            <div>
                                                <div style={{ color: "#fff" }}>Verification</div>
                                                <div style={{ color: "green", marginTop: "10px" }}>Passed</div>
                                            </div>
                                        </div>
                                        <RightOutlined style={{ color: "#888" }} />

                                    </div>

                                    <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>

                                        <div className="display-2 gap-10">
                                            <div>
                                                <MessageOutlined />
                                            </div>
                                            <span style={{ color: "#fff" }}>Support & chats</span>
                                        </div>
                                        <RightOutlined style={{ color: "#888" }} />

                                    </div>
                                    <div className="mt-10">
                                        <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                            <div>
                                                <EditOutlined style={{ marginRight: 8 }} />
                                                <span style={{ color: "#fff" }}>Edit personal data</span>
                                            </div>
                                            <RightOutlined style={{ color: "#888" }} />

                                        </div>

                                        <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                            <div>
                                                <FacebookOutlined style={{ marginRight: 8 }} />
                                                <span style={{ color: "#fff" }}>Social accounts</span>
                                            </div>
                                            <RightOutlined style={{ color: "#888" }} />

                                        </div>
                                    </div>
                                    <div className="mt-10">
                                        <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                            <div className='display-2 gap-5'>
                                                <img
                                                    width="14"
                                                    height="14"
                                                    src="https://img.icons8.com/material-outlined/24/stocks-growth.png"
                                                    style={{ filter: 'brightness(0) invert(1)' }}
                                                    alt="stocks-growth"
                                                />
                                                <span style={{ color: "#fff" }}>Trading Settings</span>
                                            </div>
                                            <RightOutlined style={{ color: "#888" }} />
                                        </div>

                                        <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                            <div className='display-2 gap-5'>
                                                <img width="14" height="14" src="https://img.icons8.com/ios-filled/50/settings.png" style={{ filter: 'brightness(0) invert(1)' }}
                                                    alt="settings--v1" />
                                                <span style={{ color: "#fff" }}>General Settings</span>
                                            </div>
                                            <RightOutlined style={{ color: "#888" }} />

                                        </div>



                                        <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                            <div className='display-2 gap-5'>
                                                <img width="14" height="14" src="https://img.icons8.com/ios-filled/50/privacy.png" style={{ filter: 'brightness(0) invert(1)' }} alt="privacy" />
                                                <span style={{ color: "#fff" }}>Privacy & Security Settings</span>
                                            </div>
                                            <RightOutlined style={{ color: "#888" }} />

                                        </div>

                                        <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                            <div className='display-2 gap-5'>
                                                <img width="14" height="14" src="https://img.icons8.com/material-outlined/24/appointment-reminders--v1.png" style={{ filter: 'brightness(0) invert(1)' }} alt="appointment-reminders--v1" />
                                                <span style={{ color: "#fff" }}>Notification Settings</span>
                                            </div>
                                            <RightOutlined style={{ color: "#888" }} />

                                        </div>

                                    </div>

                                    <div className="mt-10">
                                        <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                            <div className='display-2 gap-5'>
                                                <img width="14" height="14" src="https://img.icons8.com/material-rounded/24/terms-and-conditions.png" style={{ filter: 'brightness(0) invert(1)' }} alt="terms-and-conditions" />
                                                <span style={{ color: "#fff" }}>Terms & Conditions</span>
                                            </div>
                                            <RightOutlined style={{ color: "#888" }} />

                                        </div>
                                    </div>

                                    <div className="mt-10">
                                        <div style={{ padding: "16px 24px", display: "flex", justifyContent: "space-between" }}>
                                            <div className='display-2 gap-5'>
                                                <img width="14" height="14" src="https://img.icons8.com/ios-filled/50/logout-rounded-left.png" style={{ filter: 'invert(18%) sepia(96%) saturate(7472%) hue-rotate(355deg) brightness(100%) contrast(101%)' }}
                                                    alt="logout-rounded-left" />                                                <span style={{ color: "#f80303ff" }}>Log out</span>
                                            </div>
                                            <RightOutlined style={{ color: "#888" }} />

                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </>


                }

                <div className='display-5 pos-bot-mob align-end '>
                    <LineChartOutlined style={{ color: '#fff', fontSize: "25px" }} onClick={() => handleTabChange("chart")}
                    />
                    <FolderOpenOutlined style={{ color: '#fff', fontSize: "25px" }} onClick={() => handleTabChange("files")} />
                    <UserOutlined style={{ color: '#fff', fontSize: "25px" }} onClick={() => handleTabChange("profile")} />
                </div>
            </Content>



            {contextHolder}

        </Layout>


    );
};
export default TradeRoomMobile;